export default {
    page_title: "Kevi | Retention Report",
    title: "Retention Report",
    filters: {
        client_segment: "Client segment",
    },
    common: {
        in: "in",
        between: "between",
        and: "and",
    },
    stats: {
        average_ticket: "Average ticket",
        average_lifetime: "Average lifetime",
        average_lifetime_suffix: "Months",
        average_orders_per_client: "Per client on average",
        average_orders_suffix: "Orders",
        projected_ltv: "Projected LTV",
    },
    cohort: {
        action_label: "Action",
        segment_label: "Segment",
        select_segment: "Select a segment",
        view_by: "View cohort by:",
        view_period: "Period",
        view_orders: "Number of orders",
        interval_label: "Interval",
        interval_daily: "Daily",
        interval_weekly: "Weekly",
        interval_monthly: "Monthly",
        interval_yearly: "Yearly",
        action_order: "Placed order",
        action_joined_segment: "Joined segment",
        action_left_segment: "Left segment",
        no_data: "No data available to display",
    },
    clients: {
        title: "Clients",
        cohort: "Cohort",
        action: "Action",
        action_order: "bought",
        action_joined_segment: "joined the segment",
        action_left_segment: "left the segment",
        times_singular: "time",
        times_plural: "times",
        times_or_more: "or more",
        years_old_suffix: "years old",
        not_informed: "Not informed",
        details_button: "Details",
    },
    grid: {
        name: "Name",
        phone: "Phone",
        birthday: "Birthday",
        average_ticket: "Average Ticket (R$)",
        total_spent: "R$ Spent",
        total_orders: "Orders Placed",
        email: "E-mail",
    },
};
